const $ = jQuery.noConflict();
import Global from '../shared/global';
/* eslint-disable */
let autocomplete;
let autocompleteCurrent;
'use strict';
const Checkout = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	/** @description Initialize */
	init: function() {
		const checkout = $('body.woocommerce-checkout');
		if (checkout.length > 0) {
			this.appendPayment();
			this.appendCoupon();
			this.appendCreateAccount();
			this.appendOrderComments();
			this.appendOrderBtn();
			this.appendPersonalInfo();
			this.appendBillingAddress();
			this.appendContactOptions();
			this.appendBackBtn();
			this.checkbox();
			this.backBtn();
			this.fixedDetails();
			this.prefillFields();
			this.addressGoogleApi();
			this.checkoutLoader();
			this.thankYouPopUp();
			this.contactOption();
			this.appendContainers();
			this.removeFocus();
			// this.redirectToBooking();
			$(document).ajaxStop(function() {
				Checkout.checkbox();
				Checkout.addressGoogleApi();
				$('.woo_order_tip[data-tip="custom"]').trigger('click');
				Checkout.removeFocus();
				const cardNumber = {
					border: '2px solid #f7f9ff',
					backgroundColor: '#f7f9ff',
					padding: '10px 17px 11px',
					paddingLeft: '30px',
					maxWidth: '70%',
					width: '70%',
					height: '35px',
					borderRadius: '30px',
					'font-size': '18px',
					fontFamily: 'Goldplay, Arial, Helvetica, sans-serif',
				};

				const cvvNum = {
					border: '2px solid #f7f9ff',
					backgroundColor: '#f7f9ff',
					padding: '10px 17px 11px',
					paddingLeft: '30px',
					borderRadius: '30px',
					height: '35px',
					width: '150px',
					'font-size': '18px',
					fontFamily: 'Goldplay, Arial, Helvetica, sans-serif',
				};
				// eslint-disable-next-line no-undef
				setIfieldStyle('card-number', cardNumber);
				// eslint-disable-next-line no-undef
				setIfieldStyle('cvv', cvvNum);
			});
			const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
			if (isIOS) {
				$(document).ajaxStop(function() {
					const cardNumber = {
						border: 'none',
					};
					const cvvNum = {
						border: 'none',
					};
					// eslint-disable-next-line no-undef
					setIfieldStyle('card-number', cardNumber);
					// eslint-disable-next-line no-undef
					setIfieldStyle('cvv', cvvNum);
				});
			}
			$('#place_order').on('click', function() {
				setTimeout(function() {
					const errorMessage = $('.wc-cardknox-error');
					if (errorMessage.length) {
						$('html, body').animate({
							scrollTop: $('.wc-cardknox-error').offset().top - 200
						}, 1000);
					}
				}, 1000);
			});
		}
	},
	redirectToBooking() {
		const entries = performance.getEntriesByType('navigation');
		const entryType = entries.map(nav => nav.type);
		// if is in array (use === if is not in array)
		if (entryType.indexOf('back_forward') !== -1 && $('body.woocommerce-checkout').length > 0) {
			window.location.href = 'https://sproost.lndo.site/booking';
		}
		if (entryType.indexOf('back_forward') !== -1 && $('body.home').length > 0) {
			window.location.href = 'https://sproost.lndo.site/booking';
		}

	},
	removeFocus() {
		const tipBtn = $('.woo_order_tip_custom_text');
		if (!tipBtn) {
			return;
		}
		if (tipBtn.on('focusin')) {
			const preventFocusInput = $('#prevent-focus-on-tip');
			preventFocusInput.click().focus();
		}
	},
	addressGoogleApi() {
		const addressField = document.getElementById('billing_address_1');
		if (!addressField) {
			return;
		}

		// Create the autocomplete object, restricting the search predictions to
		// addresses in the US and Canada.
		// eslint-disable-next-line no-undef
		autocomplete = new google.maps.places.Autocomplete(addressField, {
			componentRestrictions: {country: ['us']},
			fields: ['adr_address', 'formatted_address', 'name', 'address_components', 'plus_code', 'geometry'],
			types: ['address'],
		});

		addressField.addEventListener('change', function() {
			Checkout.passAutoComplete(autocomplete);
		});
	},
	// pass autocomplete instance
	passAutoComplete: function(obj) {
		autocompleteCurrent = obj;
		autocompleteCurrent.addListener('place_changed', Checkout.fillInAddress);
	},
	// prepare address object
	fillInAddress: function() {
		// Get the place details from the autocomplete object.
		const place = autocompleteCurrent.getPlace();
		let address1 = '';

		// Get each component of the address from the place details,
		// and then fill-in the corresponding field on the form.
		// place.address_components are google.maps.GeocoderAddressComponent objects
		// which are documented at http://goo.gle/3l5i5Mr
		for (const component of place.address_components) {
			const componentType = component.types[0];
			switch (componentType) {
				case 'street_number': {
					address1 = `${component.long_name} ${address1}`;
					break;
				}
				default:
			}
		}
	},
	prefillFields() {
		const addressInput = document.getElementById('billing_address_1');
		if (!addressInput) {
			return;
		}
		const savedAddress = Global.readCookie('address');
		if (savedAddress) {
			addressInput.value = savedAddress.full_address;
		}
	},
	fixedDetails() {
		const details = $('.customer-details-right');
		const loginBox = $('.woocommerce-form-login');
		const wrap = $('.checkout__container');
		if (!details.offset()) {
			return;
		}
		const detailsPos = wrap.offset().top;
		$(window).on('scroll', function() {
			if ($(window).width() > 991) {
				if ($(window).scrollTop() > detailsPos + $('.js-login-wrap').height()) {
					details.addClass('customer-details-fixed');
				} else {
					details.removeClass('customer-details-fixed');
				}
				if ($(window).scrollTop() + $(window).height() > ($(document).height() - $('.site-footer').height())) {
					details.addClass('customer-details-bottom-fixed');
				} else {
					details.removeClass('customer-details-bottom-fixed');
				}
			}
		});
	},
	styleCardKnox() {
		const frameElement = document.getElementById('card-number');
		const doc = frameElement.contentDocument;
		// doc.body.innerHTML = doc.body.innerHTML + '<style>#data {width:45%;border-radius: 50%}</style>';
	},
	// check is checkbox is checked
	checkbox() {
		const checkbox = $('#terms-nad-cond');
		const button = $('.button-place-order-tooltip');
		const realTerms = $('.js-terms-real-input');
		$(button).addClass('not-checked');
		$(checkbox).click(function() {
			if ($(this).prop('checked') === true) {
				$(button).removeClass('not-checked');
				$(button).addClass('is-checked');
				realTerms.prop('checked', true);
			} else {
				$(button).removeClass('is-checked');
				$(button).addClass('not-checked');
				realTerms.prop('checked', false);
			}
		});
	},
	appendPayment() {
		const wrap = $('.js-credit-card-info');
		const payment = $('#payment');
		payment.appendTo(wrap);
	},
	appendCoupon() {
		const wrap = $('.js-append-coupon');
		const couponForm = $('.checkout_coupon.woocommerce-form-coupon');
		couponForm.appendTo(wrap);
	},
	appendCreateAccount() {
		const wrap = $('#customer_details');
		const form = $('.js-create-account');
		form.appendTo(wrap);
	},

	appendOrderComments() {
		const tip = $('#wooot_order_tip_form');
		const wrap = $('.js-customer-details-right');
		tip.appendTo(wrap);
	},
	appendOrderBtn() {
		const btn = $('#place_order');
		const wrap = $('.js-place-order-wrap');
		const container = $('.js-customer-details-right-wrap');
		const mobileContainer = $('.booking-block__btn--placeorder-mobile');
		btn.appendTo(wrap);
		wrap.appendTo(container);
		if ($(window).width() < 991) {
			wrap.appendTo(mobileContainer);
		}
	},

	appendPersonalInfo() {
		const title = $('.js-personal-info');
		const wrap = $('.woocommerce-billing-fields');
		title.appendTo(wrap);
	},

	appendBillingAddress() {
		const input = $('.billing-address');
		const wrap = $('.js-credit-card-info');
		input.appendTo(wrap);
	},

	appendContactOptions() {
		const contact = $('.checkout__contact-options');
		const wrap = $('.billing-name-email-phones');
		contact.appendTo(wrap);
	},

	appendContainers() {
		const link = $('.woocommerce-checkout .woocommerce-form-login-toggle');
		const notifications = $('.woocommerce-checkout .woocommerce-notices-wrapper');
		const login = $('.woocommerce-checkout .woocommerce-form-login');
		const wrap = $('.js-login-wrap');
		notifications.appendTo(wrap);
		link.appendTo(wrap);
		login.appendTo(wrap);
	},
	iOS() {
		return [
			'iPad Simulator',
			'iPhone Simulator',
			'iPod Simulator',
			'iPad',
			'iPhone',
			'iPod'
		].includes(navigator.platform)
			// iPad on iOS 13 detection
			|| (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
	},
	appendBackBtn() {
		const button = $('.js-back-btn');
		const wrap = $('.js-create-account');
		const responsiveWrap = $('#customer_details');
		button.appendTo(wrap);

		if ($(window).width() < 991) {
			button.appendTo(responsiveWrap);
		}
	},
	backBtn() {
		const btn = document.querySelector('.js-back-button');
		if (!btn) {
			return;
		}
		btn.addEventListener('click', function() {
			Global.setCookie('isBack', true);
			const formBilling = document.querySelector('.js-woocommerce-billing-fields');
			const stepsPage = formBilling.getAttribute('data-steps');
			window.location.replace(stepsPage);
		});
	},
	checkoutLoader() {
		$('form.woocommerce-checkout').on('click', '#place_order', function(e) {
			$('.js-hwcy-option').remove();
			if ($('.js-hwcy.active').length < 1) {
				e.preventDefault();
				$('.js-hwcy').parent().append('<span class="js-hwcy-option custom-step-error">Select one of the option</span>');
				// $('html, body').animate({
				// 	scrollTop: $('.js-hwcy-option').offset().top - 200
				// }, 1000);
			} else {
				$('.js-btn-loader-checkout').show();
			}

		});
	},
	thankYouPopUp() {
		const trigger = document.querySelector('.js-booked-popup-trigger');
		const btn = document.querySelector('.js-popup-thank-you-btn');
		if (!trigger || !btn) {
			return;
		}
		trigger.click();
		btn.addEventListener('click', function() {
			const close = document.querySelector('.fancybox-close-small');
			close.click();
		});
	},
	contactOption() {
		const buttons = document.querySelectorAll('.js-hwcy');
		if (!buttons) {
			return;
		}

		for (let i = 0; i < buttons.length; i++) {
			buttons[i].addEventListener('click', function() {
				$('.js-hwcy').removeClass('active');
				$('.js-hwcy-option').remove();
				this.classList.add('active');

				const data = {
					action: 'contact_way',
					contact: this.innerText
				};
				Checkout.ajaxFunc(data);

			});
			// $('.js-hwcy').on('click', function(e) {
			// 	e.preventDefault();
			// });
		}
	},
	// ajax function
	ajaxFunc: function(data) {
		$.ajax({
			type: 'POST',
			url: '/wp-admin/admin-ajax.php',
			data: data,
			success: () => {
				$('.woo_order_tip_custom_text').stopPropagation();
			}
		});
	},
};

export default Checkout;